import { render, staticRenderFns } from "./googleLens.vue?vue&type=template&id=9bd01584&scoped=true&"
import script from "./googleLens.vue?vue&type=script&lang=js&"
export * from "./googleLens.vue?vue&type=script&lang=js&"
import style0 from "./googleLens.vue?vue&type=style&index=0&id=9bd01584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd01584",
  null
  
)

export default component.exports